<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
	><path
		d="M13.846 3.782a1.136 1.136 0 0 0-1.763-.948L9.487 4.552h4.36zm0 1.539a1.136 1.136 0 0 1-1.763.948L9.487 4.552h4.36z"
	/><path
		d="M6.154 3.782a1.136 1.136 0 0 1 1.764-.948l2.595 1.718H6.154zm0 1.539a1.136 1.136 0 0 0 1.764.948l2.595-1.717H6.154zm11.043-.288h-.986c-.461 0-.876.278-1.051.705l-4.196 10.227a1.136 1.136 0 0 0 1.051 1.567h5.182c.628 0 1.137-.508 1.137-1.136V6.17c0-.628-.51-1.136-1.137-1.136M2.803 5.033h.987c.46 0 .876.278 1.05.705l4.197 10.227a1.136 1.136 0 0 1-1.052 1.567H2.803a1.136 1.136 0 0 1-1.136-1.136V6.17c0-.628.509-1.136 1.136-1.136"
	/></svg
>
